import { Box, Stack, Typography, Grid } from "@mui/material";
import { icons, images } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("vendors.head_images"),
    icon: icons?.media,
    details: [
      {
        name: (
          <Grid
            Grid
            item
            xs={12}
            sx={{
              border: " 1px dashed rgba(0, 0, 0, 0.25)",
              borderRadius: "10px",
              position: "relative",
              minHeight: "200px",
            }}
            onDragOver={(e) => e.preventDefault()}
          >
            <Stack
              justifyContent="center"
              alignItems="center"
              // height='100%'
              minHeight="214px" // Set a fixed height for the stack
            >
              <Box
                component="img"
                src={data?.logo}
                alt="img"
                width={"35%"}
                height={"100%"}
                maxHeight="214px"
                sx={{
                  borderRadius: "10px",
                }}
              />
            </Stack>
          </Grid>
        ),
      },
    ],
  },
  {
    head: t("vendors.head_details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("vendors.label_vendor_name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("vendors.label_vendor_name_ar"),
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("vendors.label_email"),
        name: data?.details?.email,
      },
      {
        label: t("vendors.label_phone_number"),
        name: `+${data?.details?.country_code}${data?.details?.phone_number}`,
      },
      {
        label: t("vendors.label_tags"),
        name: data?.tags && (
          <Stack direction="row" gap="15px">
            {data?.tags?.split(",")?.map((tag) => (
              <Box borderRadius="4px" border=" 1px solid #E6E6E6" p="5px 14px">
                <Typography>{tag}</Typography>
              </Box>
            ))}
          </Stack>
        ),
      },
      {
        label: t("vendors.label_cadeau_percentage"),
        name: data?.cadeau_percentage,
      },
    ],
  },
  {
    head: t("vendors.head_locations"),
    icon: icons.locationOutlined,
    details: data?.location?.map((location, i) => {
      return {
        name: (
          <Stack backgroundColor={"#FCFCFC"} key={i}>
            <Stack p={3}>
              <Stack gap={2}>
                <Stack>
                  <Typography
                    fontSize="16px"
                    fontFamily="Cairo"
                    color={"#9F9F9F"}
                  >
                    {t("vendors.label_city")}
                  </Typography>
                  <Typography fontSize="20px" fontFamily="Cairo">
                    {location?.google_city?.name}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    fontSize="16px"
                    fontFamily="Cairo"
                    color={"#9F9F9F"}
                  >
                    {t("vendors.label_location")}
                  </Typography>
                  <Typography fontSize="20px" fontFamily="Cairo">
                    {location?.location}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    fontSize="16px"
                    fontFamily="Cairo"
                    color={"#9F9F9F"}
                  >
                    {t("vendors.label_detailed_address")}
                  </Typography>
                  <Typography fontSize="20px" fontFamily="Cairo">
                    {location?.detailed_address}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        ),
      };
    }),
  },
];
